export default [
    // 首页
    {
        path: '/',
        name: 'Index',
        component: () =>
            import ('@/views/index.vue')
    },
    // 前言
    {
        path: '/preface',
        name: 'preface',
        component: () =>
            import ('@/views/preface.vue')
    },
    // 邀请函
    {
        path: '/invitation',
        name: 'invitation',
        component: () =>
            import ('@/views/invitation.vue')
    },
    // 产业空间布局
    {
        path: '/industrial',
        name: 'industrial',
        component: () =>
            import ('@/views/industrial.vue')
    },
    // 兰州产业链招商拓扑图
    {
        path: '/topolo',
        name: 'topolo',
        component: () =>
            import ('@/views/topolo.vue')
    },
]